export default class LoaderProgress {
  constructor() {
    this.tasks = []
    this.taskLength = 0
    this.taskResolveCount = 0
    this.onUpdateProgressAnimation = null
    this.onCompleteProgressAnimation = null
    this.progress = 0
  }

  init(
    props = {
      onUpdateProgressAnimation: (progress, onCompleteProgressAnimation) => {
        if (progress === 1) {
          onCompleteProgressAnimation()
        }
      },
      onCompleteProgressAnimationProgressAnimation: (progress) => {},
    }
  ) {
    this.onUpdateProgressAnimation = props.onUpdateProgressAnimation
    this.onCompleteProgressAnimation = props.onCompleteProgressAnimation
  }

  // taskはPromise オブジェクトを返すものにする
  add(task, taskId) {
    this.tasks.push({
      taskId: taskId,
      task: task,
    })
  }

  set() {
    this.taskLength = this.tasks.length
    this.taskResolveCount = 0
  }

  run() {
    if (!this.tasks.length) {
      this.update(1, 1)
    } else {
      this.tasks.forEach((task) => {
        task.task().then(() => {
          this.taskResolveCount++
          this.update(this.taskResolveCount, this.taskLength)
        })
      })
    }
  }

  update(resolveCount, taskLength) {
    this.progress = resolveCount / taskLength
    this.onUpdateProgressAnimation(this.progress, this.onCompleteProgressAnimation)
  }
}
